import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import Ideation from './section-components/ideation-summary';
import Footer from './global-components/footer';

const SignInPage = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Interested Project"  />
        <Ideation/>
        <Footer />
    </div>
}

export default SignInPage

